import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { message } from "antd";
import Axios from "axios";
import { paymentProvider } from "./paymentProvider";
import { redeemLoyality } from "./loyality";
import i18next from "i18next";
import moment from "moment";
import upsertPOSLog from "../../Retail/posLog";
import { verifyCredit } from "../../../../services";
import { parse } from "uuid";

export const addAmount = async (
  paymentMethod,
  value,
  grant,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  setAmount,
  setLoyalityOtpData,
  setLoyalityOtpModalVisible,
  setSelectedPaymentMethod,
  setPaytmQrCodeModalOpens,
  setQrCodeResponse,
  overPayedAmount,
  setCardPaymnetError,
  setCardPaymnetStatus,
  setLoading,
  setIsCardPaymentLoading,
  setLayoutType,
  setKioskUI,
  dispatchQRCodeEvent,
  closeQRCodeModal
) => {
  const serverUrl = process.env.REACT_APP_serverUrl;
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  const newPaymentAmount = parseFloat(value).toFixed(pricePrecision);
  const t = i18next.t;
  let setAuthTokens;
  let amountAdded;
  const authHeaders = await getOAuthHeaders();
  if (authHeaders && authHeaders.access_token) {
    setAuthTokens = authHeaders.access_token;
  }
  if (cart.payments.length > 0) {
    const currentPaymentsTotal = cart.payments
      .reduce((total, payment) => {
        const paymentAmount = parseFloat(payment.amount);
        return isNaN(paymentAmount) ? total : total + paymentAmount;
      }, 0)
      .toFixed(pricePrecision);

    // Calculate the new total by adding the currentPaymentsTotal and newPaymentAmount
    amountAdded = (parseFloat(currentPaymentsTotal) + parseFloat(newPaymentAmount)).toFixed(pricePrecision);

    // Now, amountAdded contains the sum of amounts in the payments array
  } else {
    amountAdded = parseFloat(value).toFixed(pricePrecision);
  }
  if (grant !== undefined) {
    completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, overPayedAmount, setLayoutType, setKioskUI);
  } else {
    const validation = RegExp(`^[0-9]+(.[0-9]{1,${pricePrecision}})?$`);
    let overPaymentFlag = paymentMethod?.name?.toLowerCase() !== "cash" ? cart.paid + parseFloat(value) <= cart.total + overPayedAmount : false;
    if (paymentMethod !== undefined && paymentMethod !== "" && validation.test(parseFloat(value)) && parseFloat(value) > 0) {
      const currentPaymentMethod = paymentMethod;
      if ((currentPaymentMethod.integratedPayment || currentPaymentMethod.integratedPayment === false) && overPaymentFlag) {
        paymentProvider(
          amountAdded,
          currentPaymentMethod,
          paymentMethod,
          value,
          cart,
          setCart,
          setLoader,
          setPaymentModal,
          completePayment,
          setSelectedPaymentMethod,
          setAmount,
          setPaytmQrCodeModalOpens,
          setQrCodeResponse,
          setCardPaymnetError,
          setCardPaymnetStatus,
          setLoading,
          setIsCardPaymentLoading,
          setLayoutType,
          setKioskUI,
          dispatchQRCodeEvent,
          closeQRCodeModal
        );
      }
      if (currentPaymentMethod.iscredit && overPaymentFlag) {
        cart.advancePayment = cart.advancePayment ? cart.advancePayment : 0;
        if (cart.customer.iscredit && value <= cart.total - cart.paid - cart.advancePayment) {
          setLoader(true);
          setPaymentModal(false);
          try {
            const creditResponse = await verifyCredit(cart.customer.cwrCustomerId);
            const { iscredit, creditLimit } = creditResponse.data.data.verifyCredit;
            if (iscredit) {
              if (amountAdded > 0 && amountAdded <= creditLimit) {
                {
                  message.success(`${t("credit_payment_successfull")}`);
                }
                completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, overPayedAmount, setLayoutType, setKioskUI);
              } else {
                {
                  message.warning(`${t("credit_payment_less_amount_error")}`);
                }
              }
            } else {
              message.warning("Customer not eligible for credit payment !");
            }
          } catch (err) {
            console.error(err);
            message.error("Payment Failed!");
          } finally {
            setLoader(false);
            if (tillLayout === 2) {
              setPaymentModal(true);
            }
          }
        } else {
          {
            message.warning(`${t("credit payment is can not be more than sale amount")}`);
          }
        }
      } else if (currentPaymentMethod.isloyalty && overPaymentFlag) {
        setLoader(true);
        redeemLoyality(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, setAuthTokens, completePayment);
        // setPaymentModal(false);
      } else if (currentPaymentMethod.isGiftCard && overPaymentFlag) {
        completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, overPayedAmount, setLayoutType, setKioskUI);
      } else if (
        currentPaymentMethod?.name?.toLowerCase() === "cash" ||
        (currentPaymentMethod.integratedPayment === false && currentPaymentMethod.paymentProvider === "ADC") ||
        (currentPaymentMethod.integratedPayment === false && currentPaymentMethod.paymentProvider === null)
      ) {
        completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, overPayedAmount, setLayoutType, setKioskUI);
      } else if (!overPaymentFlag) {
        message.warn("Overpayment not allowed with non-cash methods. Please adjust the amounts!");
      }
    }
  }
};

export const completePayment = (paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, overPayedAmount, setLayoutType, setKioskUI) => {
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  if (
    cart.paid + parseFloat(value) > Math.abs(cart.total + overPayedAmount).toFixed(pricePrecision) &&
    paymentMethod?.name?.toLowerCase() !== "cash" &&
    paymentMethod.roundOffForPos === "N" &&
    paymentMethod?.integratedPayment === false
  ) {
    message.warn("Overpayment not allowed with non-cash methods. Please adjust the amounts!");
    return;
  }
  const paymentAddons = cart.payments;
  const amountAdded = parseFloat(value);
  if (cart?.cardPaymentData?.manual) {
    paymentMethod = { ...paymentMethod, ...cart?.cardPaymentData?.manual };
  }
  const currentPaymentMethod = paymentMethod;
  let shouldRemoveRedeemPoints = false;

  if (paymentMethod.isloyalty && amountAdded < 0) {
    shouldRemoveRedeemPoints = true;
  }

  const index = paymentAddons.findIndex((p) => p.finPaymentmethodId === currentPaymentMethod.finPaymentmethodId);
  const cardPaymentFlag = cart.payments.some((p) => p.authorization === paymentMethod?.authorization);
  if (index >= 0 && (paymentMethod?.name?.toLowerCase() === "card" ? cardPaymentFlag : true)) {
    const newAmount = parseFloat(paymentAddons[index].amount) + parseFloat(amountAdded);
    cart.advancePayment = cart.advancePayment ? cart.advancePayment : 0;
    let paidAmount = cart.paid + parseFloat(amountAdded);
    paymentAddons[index].amount = parseFloat(newAmount).toFixed(pricePrecision);
    if (paidAmount - Math.abs(cart.total) > 0) {
      paymentAddons[index].amount = paymentAddons[index].amount - (paidAmount - Math.abs(cart.total));
      cart.change = parseFloat(parseFloat(paidAmount - Math.abs(cart.total + parseFloat(overPayedAmount))).toFixed(pricePrecision));
    }
  } else {
    if (amountAdded !== 0) {
      cart.advancePayment = cart.advancePayment ? cart.advancePayment : 0;
      let paidAmount = cart.paid + parseFloat(amountAdded);
      currentPaymentMethod.amount = parseFloat(amountAdded).toFixed(pricePrecision);
      if (paidAmount - Math.abs(cart.total) > 0) {
        currentPaymentMethod.amount = parseFloat(amountAdded).toFixed(pricePrecision) - (paidAmount - Math.abs(cart.total));
        cart.change = parseFloat(parseFloat(paidAmount - Math.abs(cart.total + parseFloat(overPayedAmount))).toFixed(pricePrecision));
      }
      paymentAddons.push(currentPaymentMethod);
    }
  }

  let totalAmountAdded = 0;
  const paymentMethodsCount = paymentAddons.length;
  for (let i = 0; i < paymentMethodsCount; i += 1) {
    totalAmountAdded += parseFloat(paymentAddons[i].amount);
  }

  if (paymentMethod.redemptionPoints) {
    cart.redemptionPoints = paymentMethod.redemptionPoints;
  }

  const redemptionPts = shouldRemoveRedeemPoints ? 0 : cart.redemptionPoints;

  let creditAmountValue = cart.creditAmount;
  if (paymentMethod.iscredit && amountAdded > 0) {
    if (cart.creditAmount > 0) {
      creditAmountValue = cart.creditAmount + amountAdded;
    } else {
      creditAmountValue = amountAdded;
    }
  }

  if (paymentMethod.iscredit && amountAdded < 0) {
    creditAmountValue = 0;
  }
  cart.total = parseFloat(cart.total.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
  if (currentPaymentMethod?.name?.toLowerCase() === "cash") {
    cart.tenderedAmount = +value + (+cart.tenderedAmount || 0);
  }
  const finalCartObj = {
    ...cart,
    paid: parseFloat(parseFloat(totalAmountAdded + cart.advancePayment).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
    payments: [...paymentAddons],
    redemptionPoints: redemptionPts,
    creditAmount: creditAmountValue,
  };

  let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
    ? JSON.parse(localStorage.getItem("orderTimeDetails"))
    : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
  if (orderTimeDetails.paymentStartTime === "") {
    orderTimeDetails = {
      ...orderTimeDetails,
      paymentStartTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"), // Update orderStartTime to current time
    };
  }

  localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
  setCart(finalCartObj);
  localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
  setSelectedPaymentMethod("");
  setAmount(
    Math.abs(cart.total) > Math.abs(totalAmountAdded) + cart.advancePayment
      ? parseFloat(Math.abs(cart.total) - (Math.abs(totalAmountAdded) + cart.advancePayment)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)
      : ""
  );
  upsertPOSLog(finalCartObj, "PAY");
  const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || {});
  const layout = userAccessController.layout;
  if (layout === "3") {
    setLayoutType(7);
    localStorage.setItem("layoutType", 7);
    const customEvent1 = new CustomEvent("customStorageChange", {
      detail: { key: "layoutType", newValue: 7 },
    });
    window.dispatchEvent(customEvent1);
    setKioskUI(5);
    const customEvent = new CustomEvent("customStorageChange", {
      detail: { key: "kioskUI", newValue: 5 },
    });
    window.dispatchEvent(customEvent);
    localStorage.setItem("kioskUI", 5);

    setTimeout(() => {
      localStorage.setItem("kioskUI", 0);
      setKioskUI(0);
      const customEvent = new CustomEvent("customStorageChange", {
        detail: { key: "kioskUI", newValue: 0 },
      });
      window.dispatchEvent(customEvent);

      localStorage.setItem("layoutType", 0);
      setLayoutType(0);
      const customEvent1 = new CustomEvent("customStorageChange", {
        detail: { key: "layoutType", newValue: 0 },
      });
      window.dispatchEvent(customEvent1);
    }, 5000);
  }
};
